document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('[data-strap-personalization]');
  if (!wrapper) return;

  var modal = wrapper.querySelector('[data-strap-modal]');

  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var openBtn = wrapper.querySelector('[data-strap-open]');
    var closeBtns = modal.querySelectorAll('[data-strap-close]');
    var form = modal.querySelector('[data-strap-form]');
    var inputOne = modal.querySelector('[data-strap-one]');
    var inputTwo = modal.querySelector('[data-strap-two]');
    var countOne = modal.querySelector('[data-strap-count-one]');
    var countTwo = modal.querySelector('[data-strap-count-two]');
    var processingCheckbox = modal.querySelector('[data-strap-processing]');
    var errorEl = modal.querySelector('[data-strap-error]');
    var submitBtn = modal.querySelector('[data-strap-submit]');
    var submitText = modal.querySelector('[data-strap-submit-text]');
    var loader = modal.querySelector('[data-strap-loader]');

    if (!form || !submitBtn) return;

  var addonVariantId = Number(wrapper.dataset.addonVariantId);
  var productFormId = wrapper.dataset.productFormId;
  var productForm = document.getElementById(productFormId);
  var productInfo = wrapper.closest('product-info') || document.querySelector('product-info');
  var estimatedShippingInput = document.querySelector('[data-estimated-shipping-property]');
  var finalSaleInput = document.querySelector('[data-final-sale-property]');
  var lastVariantId = null;

  var variantData = {};
  var variantJsonEl = document.querySelector('[data-variant-debug-json]');

  if (variantJsonEl) {
    try {
      variantData = JSON.parse(variantJsonEl.textContent);
    } catch (error) {
      console.error('[Strap Personalization] Error parsing variant JSON:', error);
    }
  }

  function openModal() {
    if (openBtn && openBtn.disabled) return;

    modal.hidden = false;
    document.body.classList.add('strap-personalization-open');

    setTimeout(function () {
      if (inputOne) inputOne.focus();
    }, 100);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('strap-personalization-open');
  }

  function setError(message) {
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.hidden = !message;
  }

  function sanitizeInput(input, counter) {
    if (!input) return;

    input.value = input.value
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, 8);

    if (counter) {
      counter.textContent = input.value.length;
    }
  }

  function generateSetId() {
    return Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).substring(2, 8).toUpperCase();
  }

  function getSelectedVariantId() {
    if (!productForm) return null;

    var variantInput = productForm.querySelector('[name="id"]');
    if (!variantInput) return null;

    return Number(variantInput.value);
  }

  function getQuantity() {
    if (!productForm) return 1;

    var quantityInput = productForm.querySelector('[name="quantity"]');
    var quantity = quantityInput ? Number(quantityInput.value) : 1;

    return quantity > 0 ? quantity : 1;
  }

  function setLoading(isLoading) {
    submitBtn.disabled = isLoading;
    submitText.textContent = isLoading ? 'Adding...' : 'Add to cart';
    loader.hidden = !isLoading;
  }

  function updatePersonalizationButton(isAvailable) {
    if (!openBtn) return;

    if (!isAvailable) {
      openBtn.disabled = true;
      openBtn.classList.add('is-disabled');

      if (!modal.hidden) {
        closeModal();
      }
    } else {
      openBtn.disabled = false;
      openBtn.classList.remove('is-disabled');
    }
  }

  function isCurrentVariantAvailable() {
    var currentVariantId = getSelectedVariantId();

    if (currentVariantId && variantData[String(currentVariantId)]) {
      return !!variantData[String(currentVariantId)].available;
    }

    if (productInfo && productInfo.dataset.variantAvailable) {
      return productInfo.dataset.variantAvailable === 'true';
    }

    if (productForm) {
      var mainSubmit = productForm.querySelector('[type="submit"]');
      if (mainSubmit && mainSubmit.disabled) {
        return false;
      }
    }

    return true;
  }

  function refreshAvailabilityFromMainButton() {
    updatePersonalizationButton(isCurrentVariantAvailable());
  }

  function openCartAfterAdd() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));

    if (window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.show();
    }
  }

  if (openBtn) {
    openBtn.addEventListener('click', openModal);
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  [inputOne, inputTwo].forEach(function (input) {
    if (!input) return;

    input.addEventListener('input', function () {
      var counter = input === inputOne ? countOne : countTwo;
      sanitizeInput(input, counter);
    });
  });

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      updatePersonalizationButton(!!event.detail.variant.available);
      return;
    }

    setTimeout(function () {
      refreshAvailabilityFromMainButton();
    }, 150);
  });

  setInterval(function () {
    var currentVariantId = getSelectedVariantId();

    if (currentVariantId && currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;

      setTimeout(function () {
        refreshAvailabilityFromMainButton();
      }, 150);
    }
  }, 300);


  refreshAvailabilityFromMainButton();
  setTimeout(refreshAvailabilityFromMainButton, 150);
  setTimeout(refreshAvailabilityFromMainButton, 400);
  setTimeout(refreshAvailabilityFromMainButton, 800);

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    setError('');

    sanitizeInput(inputOne, countOne);
    sanitizeInput(inputTwo, countTwo);

    var variantId = getSelectedVariantId();
    var quantity = getQuantity();
    var strapOne = inputOne.value.trim();
    var strapTwo = inputTwo.value.trim();

    if (!variantId) {
      setError('Please select a valid product option.');
      return;
    }

    if (!isCurrentVariantAvailable()) {
      setError('This variant is currently unavailable.');
      return;
    }

    if (!addonVariantId) {
      setError('Personalization add-on variant ID is missing.');
      return;
    }

    if (!strapOne) {
      setError('Strap 1 Personalization is required.');
      return;
    }

    if (!processingCheckbox.checked) {
      setError('Please accept the processing time notice.');
      return;
    }

    var setId = generateSetId();

    var mainProperties = {
        'Personalization Add-on': '+$8.00',
        'Personalization ID': setId,
        'Processing Time': 'Accepted',
        'Strap 1': strapOne
    };

    if (strapTwo) {
      mainProperties['Strap 2'] = strapTwo;
    }

    if (estimatedShippingInput && !estimatedShippingInput.disabled) {
        var estimatedShippingValue = estimatedShippingInput.value.trim();
        if (estimatedShippingValue) {
            mainProperties['Estimated Shipping'] = estimatedShippingValue;
        }
    }

    if (finalSaleInput) {
      var finalSaleValue = finalSaleInput.value.trim();
      if (finalSaleValue) {
        mainProperties['Final Sale'] = finalSaleValue;
      }
    }

    var payload = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: mainProperties
        },
        {
          id: addonVariantId,
          quantity: quantity,
          properties: {
            'Personalization ID': setId
          }
        }
      ]
    };

    setLoading(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Error adding personalization to cart.');
          });
        }

        return response.json();
      })
      .then(function () {
        closeModal();
        openCartAfterAdd();
      })
      .catch(function (error) {
        setError(error.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setLoading(false);
      });
  });
});